<template>
    <div class="about-wrapper">
        <app-header></app-header>
        <div class="about-content">
            <app-aside :linksArray="links"></app-aside>
            <div class="about-content-main">
              <app-about-us v-if="this.$route.params.page == 'about-us'"></app-about-us>
              <app-timeline v-if="this.$route.params.page == 'timeline'"></app-timeline>
              <app-key-figures v-if="this.$route.params.page == 'key-figures'"></app-key-figures>
              <app-mission-and-values v-if="this.$route.params.page == 'mission-and-values'"></app-mission-and-values>
              <app-rolling-plant v-if="this.$route.params.page == 'rolling-plant'"></app-rolling-plant>
              <app-extrusion-plant v-if="this.$route.params.page == 'extrusion-plant'"></app-extrusion-plant>
              <app-automotive-facility v-if="this.$route.params.page == 'automotive-facility'"></app-automotive-facility>
              <app-r-and-d v-if="this.$route.params.page == 'r-and-d'"></app-r-and-d>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "./about/Header";
import Aside from "./shared/Aside";
import AboutUs from "./about/AboutUs";
import Timeline from "./about/Timeline";
import KeyFigures from "./about/KeyFigures";
import MissionAndValues from "./about/MissionAndValues";
import RollingPlant from "./about/RollingPlant";
import ExtrusionPlant from "./about/ExtrusionPlant";
import AutomotiveFacility from "./about/AutomotiveFacility";
import RAndD from "./about/RAndD";
export default {
  components: {
    appHeader: Header,
    appAside: Aside,
    appAboutUs: AboutUs,
    appTimeline: Timeline,
    appKeyFigures: KeyFigures,
    appMissionAndValues: MissionAndValues,
    appRollingPlant: RollingPlant,
    appExtrusionPlant: ExtrusionPlant,
    appAutomotiveFacility: AutomotiveFacility,
    appRAndD: RAndD
  },
  watch: {
    // $route(to, from) {
    //   let notFound;
    //   console.log(notFound)
    //   for(let i = 0; i < this.links.length; i++) {
    //     if(this.links[i].url.split('/')[2] == this.$route.params.page) {
    //       notFound = true;
    //     }
    //   }
    //   if(notFound) {
    //     this.$router.push({ path: '*' })
    //   }
    // }
  },
  mounted() {
    if (!this.$route.params.page) {
      this.$route.params.page = "about-us";
    }
  },
  data() {
    return {
      links: [
        { name: "За нас", url: "/about-the-company/about-us" },
        {
          name: "Мисия и ценности",
          url: "/about-the-company/mission-and-values"
        },
        { name: "Компанията в цифри", url: "/about-the-company/key-figures" },
        { name: "Развойна дейност", url: "/about-the-company/r-and-d" },
        {
          name: "Валцово производство",
          url: "/about-the-company/rolling-plant"
        },
        {
          name: "Пресово производство",
          url: "/about-the-company/extrusion-plant"
        },
        {
          name: "Автомобилен цех",
          url: "/about-the-company/automotive-facility"
        },
        { name: "История", url: "/about-the-company/timeline" }
      ]
    };
  }
};
</script>

<style scoped>
.about-content {
  display: flex;
}
.about-content-main {
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .about-content-main {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue